import client from '../client';
import endpoints from '../endpoints';

/* ── 서비스 (유저용) ── */

/** GET /api/waitlist */
export const getWaitlist = async (params = {}) => {
  const res = await client.get(endpoints.waitlist.list, { params });
  return res.data;
};

/** POST /api/waitlist */
export const createWaitlist = async (data) => {
  const res = await client.post(endpoints.waitlist.create, data);
  return res.data;
};

/** DELETE /api/waitlist/:id */
export const cancelWaitlist = async (id) => {
  const res = await client.delete(endpoints.waitlist.cancel(id));
  return res.data;
};

/** POST /api/waitlist/:id/convert */
export const convertWaitlist = async (id) => {
  const res = await client.post(endpoints.waitlist.convert(id));
  return res.data;
};

/* ── 관리자 ── */

/** GET /api/admin/waitlist */
export const getAdminWaitlist = async (params = {}) => {
  const res = await client.get(endpoints.admin.waitlist.list, { params });
  return res.data;
};

/** POST /api/admin/waitlist/:id/notify */
export const notifyAdminWaitlist = async (id) => {
  const res = await client.post(endpoints.admin.waitlist.notify(id));
  return res.data;
};
